<template>
  <custom-select ref="select"
    class="guest-picker"
    :value="value"
    @input="handleInput"
    placeholder="Add guests"
    :options="guests"
  />
</template>

<script>
import {
  syncURLParams
} from '../../helpers/searchHelpers'
import Responsive from '../../components/core/Responsive'
import CustomSelect from '../../components/core/CustomSelect'

export default {
  components: {
    CustomSelect,
    Responsive
  },
  props: ['value'],
  computed: {
    guests () {
      return [
        { value: '1', label: '1 guest' },
        { value: '2', label: '2 guests' },
        { value: '3', label: '3 guests' },
        { value: '4', label: '4 guests' },
        { value: '5', label: '5 guests' },
        { value: '6', label: '6 guests' },
        { value: '7', label: '7 guests' },
        { value: '8', label: '8 guests' },
        { value: '9', label: '9 guests' },
        { value: '10+', label: '10+ guests' }
      ]
    }
  },
  methods: {
    ask () {
      this.$refs.select.show()
    },
    handleInput (e) {
      this.$emit('input', e)
    }
  },
  watch: {
    value (guests) {
      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('guests', guests)

      syncURLParams(searchParams)
    }
  }
}
</script>
